import Image from "next/image";
import React from "react";
import { ImagePlayerAction } from "../../modal/funUGCModal.component";
import FunLoading from "../Loading/funLoading";
import styles from "./ImagePlayer.module.scss";

interface ImagePlayerProps {
  imageSrc: string;
  imageState: ImagePlayerAction;
  customControls: JSX.Element;
  setImageState: React.Dispatch<React.SetStateAction<ImagePlayerAction>>;
}

const ImagePlayer = ({
  imageSrc,
  imageState,
  setImageState,
  customControls
}: ImagePlayerProps) => {
  return (
    <>
      {imageState === "Loading" && (
        <div className={styles.loading}>
          <FunLoading size={50} />
        </div>
      )}

      <div className={styles.imageContainer}>
        <Image
          src={imageSrc}
          layout="fill"
          alt=""
          onLoadingComplete={() => setImageState("Play")}
          priority={true}
        />
      </div>
      {customControls}
    </>
  );
};

export default ImagePlayer;
